import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";

import { Context } from "../backend/context";
import { Redirect } from "react-router";
import Navbar from "./navbar";
import Bot from "./bot";
import Settings from "./settings";
import Notifications from "./notifications";
import Dashboard from "./dashboard";
import CreateBot from "./createbot";
import Leaderboard from "./leaderBoard";

import firebase from "firebase/app";
import "firebase/database";

import { connect } from "react-redux";
import { setNotificationData } from "../actions/notificationAction";
import { setAllBotsCount } from "../actions/allBotsCountAction";
import { setVolumeNprofit } from "../actions/volumeNprofitAction";
import { setPendingOrders } from "../actions/pendingOrdersAction";
import { setFilledOrders } from "../actions/filledOrdersAction";
import { setCancelledOrders } from "../actions/cancelledOrdersAction";
import SendTip from "./sendTip";

import worker from "workerize-loader!../backend/worker"; // eslint-disable-line import/no-webpack-loader-syntax
import createBotAdvanced from "./createBotAdvanced";
import createBotBeginner from "./createBotBeginner";
// Create an instance of your worker
const workerInstance = worker();
// Attach an event listener to receive calculations from your worker

function User(props) {
  const { isLoggedIn, user, maintenance, uid, realTimeData } = React.useContext(
    Context
  );
  const [display, setDisplay] = useState("none");

  const [isUnsubcribed, setUnsubcribed] = useState(false);

  useEffect(() => {
    if (uid) {
      getNotifications();
      getTotalBots();
      // getVolumeNprofit();
      getPendingOrders();
      // getFilledOrders();
      getCancelledOrders();
      setTimeout(timeOutHandler, 3600000);
    }

    workerInstance.addEventListener("message", (message) => {
      if (message.data && message.data.type === "volumeNprofit") {
        props.setVolumeNprofit(message.data.data);
      } else if (message.data && message.data.type === "pendingOrders") {
        props.setPendingOrders(message.data.data);
      } else if (message.data && message.data.type === "filledOrders") {
        props.setFilledOrders(message.data.data);
      } else if (message.data && message.data.type === "cancelledOrders") {
        props.setCancelledOrders(message.data.data);
      } else if (message.data && message.data.type === "notifications") {
        var unreadCount = message.data.data.unreadCount;
        var list = message.data.data.list;
        var str =
          unreadCount === 99
            ? ` | ${unreadCount}+`
            : unreadCount !== 0
            ? ` | ${unreadCount}`
            : "";
        document.title = "Nash TradingBot" + str;
        props.setNotificationData(list, unreadCount);
      }
    });

    return () => {
      unsubcribeALL();
      firebase
        .database()
        .ref("/userNotifications/" + uid + "/notifications")
        .orderByChild("createdAt")
        .off();
      firebase.database().ref("botsCount").off();
    };
  }, [uid]);

  const unsubcribeALL = () => {
    setUnsubcribed(true);
    firebase
      .database()
      .ref("/volumeNprofit/" + uid)
      .off();
    firebase
      .database()
      .ref("/pendingOrders/" + uid)
      .off();
    firebase
      .database()
      .ref("/cancelledOrders/" + uid)
      .off();
    firebase
      .database()
      .ref("/filledOrders/" + uid)
      .off();
  };
  const getNotifications = () => {
    // console.log("getting notifications");
    firebase
      .database()
      .ref("/userNotifications/" + uid + "/notifications")
      .orderByChild("createdAt")
      .limitToLast(99)
      .on("value", (snapshot) => {
        workerInstance.getNotifications(snapshot.val());
      });
  };
  const getTotalBots = () => {
    var botsCountRef = firebase.database().ref("botsCount");
    botsCountRef.on("value", (snapshot) => {
      props.setAllBotsCount(snapshot.numChildren());
    });
  };
  const getVolumeNprofit = () => {
    firebase
      .database()
      .ref("/volumeNprofit/" + uid)
      .on("value", (snapshot) => {
        workerInstance.getVolumeNprofit(snapshot.val());
      });
  };
  const getPendingOrders = () => {
    firebase
      .database()
      .ref("/pendingOrders/" + uid)
      .on("value", (snapshot) => {
        workerInstance.getPendingOrders(snapshot.val());
      });
  };
  const getFilledOrders = () => {
    // console.log("filled orders listner on");
    firebase
      .database()
      .ref("/filledOrders/" + uid)
      .on("value", (snapshot) => {
        workerInstance.getFilledOrders(snapshot.val());
      });
  };
  const getCancelledOrders = () => {
    firebase
      .database()
      .ref("/cancelledOrders/" + uid)
      .on("value", (snapshot) => {
        workerInstance.getCancelledOrders(snapshot.val());
      });
  };

  var timestamp = Date.now();

  const timeOutHandler = () => {
    if (uid && Date.now() - timestamp > 3000000) {
      setDisplay("block");
      // console.log("timeout");
      unsubcribeALL();
    } else {
      setTimeout(timeOutHandler, 3600000);
    }
  };
  const getMouseMove = () => {
    timestamp = Date.now();
    if (display === "block") {
      setDisplay("none");

      if (isUnsubcribed) {
        getPendingOrders();
        getCancelledOrders();
        checkRealTimeUpdates();
      }
      setTimeout(timeOutHandler, 3600000);
    }
  };
  function checkRealTimeUpdates() {
    if (
      (realTimeData && realTimeData.volumeNprofit) ||
      realTimeData === undefined ||
      realTimeData.volumeNprofit === undefined
    ) {
      firebase
        .database()
        .ref("/volumeNprofit/" + uid)
        .off();
      // console.log("volume listner offed");
      getVolumeNprofit();
      // console.log("volume listner on");
    } else {
      firebase
        .database()
        .ref("/volumeNprofit/" + uid)
        .off();
      firebase
        .database()
        .ref("/volumeNprofit/" + uid)
        .once("value", (snapshot) => {
          // console.log(snapshot.val());
          workerInstance.getVolumeNprofit(snapshot.val());
        });
      // console.log("volume listner offed");
    }
    if (
      (realTimeData && realTimeData.filledOrders) ||
      realTimeData === undefined ||
      realTimeData.filledOrders === undefined
    ) {
      firebase
        .database()
        .ref("/filledOrders/" + uid)
        .off();

      // console.log("filled orders listner offed");
      getFilledOrders();
    } else {
      firebase
        .database()
        .ref("/filledOrders/" + uid)
        .off();
      firebase
        .database()
        .ref("/filledOrders/" + uid)
        .once("value", (snapshot) => {
          // console.log(snapshot.val());
          workerInstance.getFilledOrders(snapshot.val());
        });
      console.log("filled orders listner offed");
    }
  }

  useEffect(() => {
    if (uid) {
      checkRealTimeUpdates();
    }
  }, [realTimeData]);

  return (
    <div
      onMouseMove={getMouseMove}
      className="badge-dark h-100 overflow-scroll"
      style={{ maxHeight: "100%" }}
    >
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      {maintenance && <Redirect to="/maintenance" />}
      <Navbar />
      <div
        style={{
          display: display,
          position: "fixed",
          zIndex: "1",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          overflow: "auto",
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
      ></div>

      <Switch>
        <Route exact path="/account/createBot" component={CreateBot} />
        <Route
          exact
          path="/account/createBot/beginner"
          component={createBotBeginner}
        />
        <Route
          exact
          path="/account/createBot/advanced"
          component={createBotAdvanced}
        />
        <Route exact path="/account/bot/:id" component={Bot} />
        <Route path="/account/settings" component={Settings} />
        <Route path="/account/notifications" component={Notifications} />
        <Route path="/account/leaderboard" component={Leaderboard} />
        <Route path="/account/send-tip" component={SendTip} />
        <Route path="/account" component={Dashboard} />
      </Switch>
    </div>
  );
}

export default connect(null, {
  setNotificationData,
  setAllBotsCount,
  setVolumeNprofit,
  setPendingOrders,
  setCancelledOrders,
  setFilledOrders,
})(User);
